import { BlocksIconReorder } from 'blocks-nextjs/blocks-web-components/components/icon/icons/reorder';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconReorder = createComponent({ react: React, tagName: 'cat-icon-reorder', elementClass: BlocksIconReorder });
